import { cn } from "../../lib/utils";
import { Check } from "lucide-react";

/**
 * Stepper orizzontale numerato.
 *
 * Props:
 *   steps:        Array<{ id: string, label: string }>
 *   currentStep:  indice 0-based dello step corrente
 *   onStepChange: (index: number) => void — opzionale, abilita click su step completati
 */
export function Stepper({ steps = [], currentStep = 0, onStepChange }) {
  return (
    <div className="flex items-center w-full">
      {steps.map((step, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;
        const isLast = index === steps.length - 1;

        return (
          <div key={step.id} className="flex items-center flex-1 min-w-0">
            {/* Step circle + label */}
            <div
              className={cn(
                "flex items-center gap-2 shrink-0",
                onStepChange && isCompleted ? "cursor-pointer" : "cursor-default"
              )}
              onClick={() => {
                if (onStepChange && isCompleted) onStepChange(index);
              }}
            >
              <div
                className={cn(
                  "w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold border-2 transition-all",
                  isCompleted
                    ? "bg-emerald-500 border-emerald-500 text-white"
                    : isCurrent
                    ? "bg-white border-[#4CAF50] text-[#4CAF50]"
                    : "bg-white border-slate-300 text-slate-400"
                )}
              >
                {isCompleted ? <Check className="w-3.5 h-3.5" /> : index + 1}
              </div>
              <span
                className={cn(
                  "text-xs font-medium whitespace-nowrap hidden sm:inline",
                  isCurrent
                    ? "text-[#4CAF50]"
                    : isCompleted
                    ? "text-slate-600"
                    : "text-slate-400"
                )}
              >
                {step.label}
              </span>
            </div>

            {/* Connettore */}
            {!isLast && (
              <div
                className={cn(
                  "flex-1 h-0.5 mx-2 transition-all",
                  isCompleted ? "bg-emerald-400" : "bg-slate-200"
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
